export { default } from "./SEO"